export default __webpack_public_path__ + "static/reactColors-e36b6438ef66e6eca1d4ccbd9581c08d.png";